<template>
	<Popup
		v-model="selfDisplay"
		title="修改类型"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>类型名称</span>
				<el-input v-model="name" placeholder="类型名称"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入类型名称</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>分类</span>
				<el-select v-model="type" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in iAssistantSortType" :key="v.id" :value="v.id" :label="v.label"></el-option>
				</el-select>
			</div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				name: '',
				type: 1,
				nameTip: false
			}
		},
		computed: {
			...mapState([
				'iAssistantSortType'
			])
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					id: that.obj.id,
					catName: that.name,
					catType: that.type
				};
				Api.updateIAssistantSort(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.name = this.obj.name;
					this.type = this.obj.typeId;
					this.nameTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
